// import React from 'react';
// import { 
//   HeartHandshake, BookOpen, ShieldCheck, Landmark, 
//   Scroll, FileText, Users, Building, 
//   CheckCircle, AlertCircle 
// } from 'lucide-react'; // run: npm i lucide-react
// import { ServicePageHeader } from '../ServicePageHeader';

// export default function WaqfAndWillServices() {
  
//   // Specific areas of service regarding Awqaf and Wills
//   const coreServices = [
//     {
//       title: "صياغة وتأسيس صكوك الأوقاف",
//       desc: "صياغة الحجج الوقفية للأصول العقارية والنقدية والأسهم، بطريقة تضمن استدامتها النماء واستغلال ريعها في المصارف الشرعية المحددة.",
//       icon: <Scroll className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "الحوكمة وهيكلة النظارة الوقفية",
//       desc: "وضع اللوائح الداخلية لمجالس النظارة، تحديد صلاحيات الناظر، ورسم آليات الرقابة والمحاسبة لضمان أعلى درجات الشفافية والامتثال لحوكمة الأوقاف.",
//       icon: <Landmark className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "تحويل الأوقاف إلى أشكال شركات",
//       desc: "مواكبة للأنظمة الحديثة، نقوم بتحويل إدارة الأوقاف الكبرى إلى شركات وقفية مغلقة لتمكينها من الاستثمار المرن وتطوير أصولها بمهنية.",
//       icon: <Building className="w-6 h-6 text-amber-600" />
//     },
//     {
//       title: "كتابة وتوثيق الوصايا الشرعية",
//       desc: "إعداد وصايا الأفراد والشركاء بما لا يتجاوز الثلث الشرعي، وضمان خلوها من أي عيوب أو ثغرات نظامية قد تؤدي لإبطالها بعد الوفاة.",
//       icon: <FileText className="w-6 h-6 text-amber-600" />
//     }
//   ];

//   return (
//     <div className="bg-white text-right font-sans" dir="rtl">
//       <ServicePageHeader 
//         title="خدمات الأوقاف والوصايا الشرعية"
//         description="نقدم حلولاً قانونية وشرعية متكاملة لدعم نمو الشركات الناشئة وريادة الأعمال في السوق السعودي"
//       />
//       {/* Hero Header Section */}
//       <section className="relative bg-slate-900 text-white py-24 px-4 overflow-hidden">
//         <div className="absolute inset-0 opacity-15 bg-[url('https://images.unsplash.com/photo-1455390582262-044cdead277a?auto=format&fit=crop&q=80')] bg-cover bg-center"></div>
//         <div className="max-w-6xl mx-auto relative z-10 text-center">
//           <span className="text-amber-500 font-semibold text-sm md:text-base tracking-wide block mb-3">تخليد الأثر وحماية الثروات</span>
//           <h1 className="text-3xl md:text-5xl font-bold mb-6 text-slate-100 leading-tight">خدمات الأوقاف والوصايا الشرعية</h1>
//           <p className="text-slate-300 max-w-3xl mx-auto text-base md:text-lg leading-relaxed">
//             نساعد عملائنا في صياغة وإثبات أوقافهم ووصاياهم وفق القواعد الفقهية والأنظمة السعودية الحديثة، مما يضمن بقاء أثرهم الصالح، واستمرار نمو ثرواتهم، وحفظ تماسك عائلاتهم.
//           </p>
//         </div>
//       </section>

//       {/* Concept Breakdown */}
//       <section className="max-w-6xl mx-auto py-20 px-4">
//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
//           <div>
//             <h2 className="text-2xl md:text-4xl font-bold text-slate-800 mb-6 leading-tight">
//               نظرة حديثة لإدارة الأوقاف المستدامة
//             </h2>
//             <p className="text-gray-600 text-lg leading-relaxed mb-4">
//               لم يعد الوقف مقتصراً على الأشكال التقليدية الجامدة، بل أصبح اليوم أداة استثمارية وتنموية بالغة القوة. الوقف المصاغ بطرق احترافية يحمي الشركات العائلية من التفتت، ويمنح الأصول حصانة قانونية دائمة ضد أي نزاعات شخصية أو عائلية.
//             </p>
//             <p className="text-gray-600 text-lg leading-relaxed">
//               نحن نجمع بين العمق الفقهي في أحكام المواريث والوصايا، وبين الأنظمة التجارية الصادرة عن وزارة التجارة والهيئة العامة للأوقاف، لنمنح منشأتك وأموالك صياغة وقائية متكاملة ومستدامة.
//             </p>
//           </div>
          
//           {/* Visual Highlight block */}
//           <div className="bg-slate-50 p-8 rounded-2xl border border-slate-100 space-y-6">
//             <h3 className="text-xl font-bold text-slate-800 mb-2 flex items-center gap-2">
//               <HeartHandshake className="w-5 h-5 text-amber-600" /> أهدافنا الأساسية في هذا القطاع:
//             </h3>
            
//             <div className="flex gap-3 items-start">
//               <CheckCircle className="w-5 h-5 text-amber-600 shrink-0 mt-1" />
//               <p className="text-gray-600 text-sm leading-relaxed">ضمان تنفيذ رغبة الواقف أو الموصي بدقة متناهية دون احتمالات تأويل خاطئ.</p>
//             </div>

//             <div className="flex gap-3 items-start">
//               <CheckCircle className="w-5 h-5 text-amber-600 shrink-0 mt-1" />
//               <p className="text-gray-600 text-sm leading-relaxed">بناء أنظمة نظارة قوية تمنع انفراد ناظر واحد بالقرارات المالية الكبرى للأصول.</p>
//             </div>

//             <div className="flex gap-3 items-start">
//               <CheckCircle className="w-5 h-5 text-amber-600 shrink-0 mt-1" />
//               <p className="text-gray-600 text-sm leading-relaxed">تسجيل وإثبات الأوقاف أمام المحاكم المختصة وإنهاء كافة الإجراءات مع الهيئات التنظيمية.</p>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Service Blocks Grid */}
//       <section className="bg-slate-900 text-white py-20 px-4">
//         <div className="max-w-6xl mx-auto">
//           <div className="text-center mb-16">
//             <h2 className="text-2xl md:text-4xl font-bold mb-3">نطاق خبراتنا في الأوقاف والوصايا</h2>
//             <p className="text-slate-400 max-w-xl mx-auto">نصمم الهياكل الشرعية والنظامية التي تضمن الأمان القانوني التام لخططك المستقبلية</p>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//             {coreServices.map((service, index) => (
//               <div key={index} className="bg-slate-800/60 p-8 rounded-xl border border-slate-700 hover:border-amber-500 transition-all duration-300">
//                 <div className="bg-slate-700/50 p-3 rounded-lg w-fit mb-5">
//                   {service.icon}
//                 </div>
//                 <h3 className="text-xl font-bold text-slate-100 mb-2">{service.title}</h3>
//                 <p className="text-slate-400 text-sm leading-relaxed">{service.desc}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Advisory Alert Banner */}
//       <section className="max-w-4xl mx-auto py-16 px-4">
//         <div className="bg-amber-50 rounded-xl border border-amber-200 p-6 flex gap-4 items-start">
//           <AlertCircle className="w-6 h-6 text-amber-600 shrink-0 mt-0.5" />
//           <div>
//             <h4 className="font-bold text-slate-800 mb-1">تنبيه نظامي حرج:</h4>
//             <p className="text-amber-950 text-sm leading-relaxed">
//               وفقاً لنظام الأحوال الشخصية المعمول به في المملكة العربية السعودية، هناك شروط وضوابط دقيقة جداً لصحة الوصية ونفاذها (مثل ألا تكون لوارث إلا بإجازة بقية الورثة، وألا تتجاوز ثلث التركة الكلية). كتابة الوصايا بصيغ عامة أو دون توثيق نظامي رسمي قد يعرضها للبطلان والطعن القضائي المباشر بعد الوفاة.
//             </p>
//           </div>
//         </div>
//       </section>

//     </div>
//   );
// }

import React from 'react';
import { 
  HeartHandshake, BookOpen, ShieldCheck, Landmark, 
  Scroll, FileText, Users, Building, 
  CheckCircle, AlertCircle 
} from 'lucide-react';
import { ServicePageHeader } from '../ServicePageHeader';

export default function WaqfAndWillServices() {
  
  // Specific areas of service regarding Awqaf and Wills - Refactored to Navy Light
  const coreServices = [
    {
      title: "صياغة وتأسيس صكوك الأوقاف",
      desc: "صياغة الحجج الوقفية للأصول العقارية والنقدية والأسهم، بطريقة تضمن استدامتها النماء واستغلال ريعها في المصارف الشرعية المحددة.",
      icon: <Scroll className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "الحوكمة وهيكلة النظارة الوقفية",
      desc: "وضع اللوائح الداخلية لمجالس النظارة، تحديد صلاحيات الناظر، ورسم آليات الرقابة والمحاسبة لضمان أعلى درجات الشفافية والامتثال لحوكمة الأوقاف.",
      icon: <Landmark className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "تحويل الأوقاف إلى أشكال شركات",
      desc: "مواكبة للأنظمة الحديثة، نقوم بتحويل إدارة الأوقاف الكبرى إلى شركات وقفية مغلقة لتمكينها من الاستثمار المرن وتطوير أصولها بمهنية.",
      icon: <Building className="w-6 h-6 text-indigo-950" />
    },
    {
      title: "كتابة وتوثيق الوصايا الشرعية",
      desc: "إعداد وصايا الأفراد والشركاء بما لا يتجاوز الثلث الشرعي، وضمان خلوها من أي عيوب أو ثغرات نظامية قد تؤدي لإبطالها بعد الوفاة.",
      icon: <FileText className="w-6 h-6 text-indigo-950" />
    }
  ];

  return (
    <div className="bg-white text-right font-sans min-h-screen" dir="rtl">
      <ServicePageHeader 
        title="خدمات الأوقاف والوصايا الشرعية"
        description="نصمم الهياكل الشرعية والنظامية التي تضمن استدامة ثرواتكم وتخليد أثركم الصالح عبر الأجيال"
      />
      
      {/* Hero Header Section - Converted to Premium Light Mode */}
      <section className="relative bg-slate-50 border-b border-slate-100 py-24 px-4 overflow-hidden">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1455390582262-044cdead277a?auto=format&fit=crop&q=80')] bg-cover bg-center"></div>
        {/* White/Slate overlay for premium executive appearance */}
        <div className="absolute inset-0 bg-white/90 backdrop-blur-[1px]"></div>
        
        <div className="max-w-6xl mx-auto relative z-10 text-center">
          <span className="text-blue-700 font-bold text-xs md:text-sm tracking-wide block mb-3 uppercase">تخليد الأثر وحماية الثروات</span>
          <h1 className="text-3xl md:text-5xl font-extrabold mb-6 text-indigo-950 leading-tight">خدمات الأوقاف والوصايا الشرعية</h1>
          <p className="text-slate-600 max-w-3xl mx-auto text-base md:text-lg leading-relaxed font-light">
            نساعد عملائنا في صياغة وإثبات أوقافهم ووصاياهم وفق القواعد الفقهية والأنظمة السعودية الحديثة، مما يضمن بقاء أثرهم الصالح، واستمرار نمو ثرواتهم، وحفظ تماسك عائلاتهم.
          </p>
        </div>
      </section>

      {/* Concept Breakdown */}
      <section className="max-w-6xl mx-auto py-20 px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-2xl md:text-4xl font-extrabold text-indigo-950 mb-6 leading-tight">
              نظرة حديثة لإدارة الأوقاف المستدامة
            </h2>
            <p className="text-slate-600 text-base md:text-lg leading-relaxed mb-4 font-light">
              لم يعد الوقف مقتصراً على الأشكال التقليدية الجامدة، بل أصبح اليوم أداة استثمارية وتنموية بالغة القوة. الوقف الُمصاغ بطرق احترافية يحمي الشركات العائلية من التفتت، ويمنح الأصول حصانة قانونية دائمة ضد أي نزاعات شخصية أو عائلية.
            </p>
            <p className="text-slate-600 text-base md:text-lg leading-relaxed font-light">
              نحن نجمع بين العمق الفقهي في أحكام المواريث والوصايا، وبين الأنظمة التجارية الصادرة عن وزارة التجارة والهيئة العامة للأوقاف، لنمنح منشأتك وأموالك صياغة وقائية متكاملة ومستدامة.
            </p>
          </div>
          
          {/* Visual Highlight block - Refactored to Executive Light Mode */}
          <div className="bg-slate-50 p-8 rounded-2xl border border-slate-200/60 space-y-6 shadow-sm">
            <h3 className="text-xl font-bold text-indigo-950 mb-2 flex items-center gap-2">
              <HeartHandshake className="w-5 h-5 text-blue-700" /> أهدافنا الأساسية في هذا القطاع:
            </h3>
            
            <div className="flex gap-3 items-start">
              <CheckCircle className="w-5 h-5 text-indigo-950 shrink-0 mt-1" />
              <p className="text-slate-600 text-sm leading-relaxed font-light">ضمان تنفيذ رغبة الواقف أو الموصي بدقة متناهية دون احتمالات تأويل خاطئ.</p>
            </div>

            <div className="flex gap-3 items-start">
              <CheckCircle className="w-5 h-5 text-indigo-950 shrink-0 mt-1" />
              <p className="text-slate-600 text-sm leading-relaxed font-light">بناء أنظمة نظارة قوية تمنع انفراد ناظر واحد بالقرارات المالية الكبرى للأصول.</p>
            </div>

            <div className="flex gap-3 items-start">
              <CheckCircle className="w-5 h-5 text-indigo-950 shrink-0 mt-1" />
              <p className="text-slate-600 text-sm leading-relaxed font-light">تسجيل وإثبات الأوقاف أمام المحاكم المختصة وإنهاء كافة الإجراءات مع الهيئات التنظيمية.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Service Blocks Grid - Converted to Premium Light Grid */}
      <section className="bg-slate-50/50 border-y border-slate-100 py-20 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-2xl md:text-4xl font-extrabold text-indigo-950 mb-3">نطاق خبراتنا في الأوقاف والوصايا</h2>
            <p className="text-slate-500 text-sm md:text-base font-light">نصمم الهياكل الشرعية والنظامية التي تضمن الأمان القانوني التام لخططك المستقبلية</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {coreServices.map((service, index) => (
              <div key={index} className="bg-white p-8 rounded-xl border-t-4 border-t-indigo-950 border-x border-b border-slate-100 shadow-sm hover:shadow-md transition-all duration-300">
                <div className="bg-slate-50 p-3 rounded-lg w-fit mb-5">
                  {service.icon}
                </div>
                <h3 className="text-xl font-bold text-indigo-950 mb-2">{service.title}</h3>
                <p className="text-slate-600 text-sm leading-relaxed font-light">{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Advisory Alert Banner - Adjusted to Slate Balance Tone */}
      <section className="max-w-4xl mx-auto py-20 px-4">
        <div className="bg-slate-50 rounded-xl border border-slate-200/60 p-6 flex gap-4 items-start shadow-sm">
          <AlertCircle className="w-6 h-6 text-indigo-950 shrink-0 mt-0.5" />
          <div>
            <h4 className="font-bold text-indigo-950 mb-1">تنبيه نظامي حرج:</h4>
            <p className="text-slate-600 text-sm leading-relaxed font-light">
              وفقاً لنظام الأحوال الشخصية المعمول به في المملكة العربية السعودية، هناك شروط وضوابط دقيقة جداً لصحة الوصية ونفاذها (مثل ألا تكون لوارث إلا بإجازة بقية الورثة، وألا تتجاوز ثلث التركة الكلية). كتابة الوصايا بصيغ عامة أو دون توثيق نظامي رسمي قد يعرضها للبطلان والطعن القضائي المباشر بعد الوفاة.
            </p>
          </div>
        </div>
      </section>

    </div>
  );
}